import { render } from "./EntityManagerModal.vue?vue&type=template&id=3748455c&scoped=true"
import script from "./EntityManagerModal.vue?vue&type=script&lang=js"
export * from "./EntityManagerModal.vue?vue&type=script&lang=js"

import "./EntityManagerModal.vue?vue&type=style&index=0&id=3748455c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3748455c"]])

export default __exports__